
export interface IMenu {
    menuID: number;
    proyectoID: number;
    menuPadreID: number | null;
    nombre: string;
    descripcion: string;
    icono: string;
    linkTipo: LinkTipo;
    linkIFrame: string | null;
    linkTipoNombre: string;
    link: string;
    orden: number;
    menuHijos: IMenu[] | null;
    menuCRUD: IMenuCRUD[];
}

export interface IMenuCRUD {
    rolMenuCRUDID: number;
    rolMenuID: number;
    crudTipo: CRUDTipo;
    crudTipoNombre: string;
}

export enum CRUDTipo {
    Leer = 1,
    Crear = 2,
    Modificar = 3,
    Eliminar = 4,
    Copiar = 5
}

export enum LinkTipo {
    Menu = 1,
    Modulo = 2,
    IFrame = 3
}


export enum LinkRuta {
    Principal = '/',
    Atributos = '/atributos',
    Usuarios = '/usuarios',
    GrupoUsuarios = '/grupoUsuarios',
    Listados = '/listados',
    GrupoPreguntas = '/grupoPreguntas',
    Formularios = '/formularios',
    Encuesta = '/encuesta',
    HistoricoUsuario = '/historicoUsuario',
    Historico = '/historico',
}